var React = require('react');

function GreaterThan (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M18.49 358L237 256.1 18.53 154.25A32.09 32.09 0 0 1 3 111.61l13.58-29.08A32.09 32.09 0 0 1 59.22 67l306.3 142.84a32 32 0 0 1 18.49 29v34.23a32 32 0 0 1-18.48 29L59.06 445a32 32 0 0 1-42.53-15.48L3 400.52A32 32 0 0 1 18.49 358z","className":"fa-secondary","key":1})]);
}

GreaterThan.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = GreaterThan;

GreaterThan.default = GreaterThan;
